import React, { useState } from 'react';
import { opsLogin } from '../services/api';
import { Shield, LogIn } from 'lucide-react';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await opsLogin(email, password);
      onLogin(data.personnel, data.accessToken);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <div className="sidebar-logo" style={{ width: 48, height: 48, fontSize: 24 }}>S</div>
          <div>
            <h1>SOS GUARDIAN</h1>
            <p style={{ margin: 0 }}>Operations Center Access</p>
          </div>
        </div>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email" className="form-input" placeholder="operator@sosguardian.local"
              value={email} onChange={e => setEmail(e.target.value)} required autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password" className="form-input" placeholder="••••••••"
              value={password} onChange={e => setPassword(e.target.value)} required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: 8 }}>
            <LogIn size={16} />
            {loading ? 'Authenticating...' : 'Sign In to Ops Center'}
          </button>
        </form>

        <div style={{ marginTop: 24, fontSize: 11, color: 'var(--text-muted)', textAlign: 'center' }}>
          Demo: admin@sosguardian.local / admin123
        </div>
      </div>
    </div>
  );
}
